@if (view.site?.id !== 77) {
<section
    class="w-full bg-cover bg-no-repeat bg-center dark:bg-slate-800 pb-20 px-6 md:px-15 border-b-2 border-primary-500"
    [ngClass]="view.site?.id === 11 ? 'pt-0 pb-10 md:pb-12' : ''">
    <div class="flex flex-col items-center justify-center" [ngClass]="view.site?.id === 11 ? 'mt-0 mb-4' : 'my-6'">
        <div class="w-full flex justify-center items-center">
            <div class="flex flex-col justify-center items-center sm:pl-5 sm:pr-5 sm:items-center text" [ngClass]="view.site?.id === 11 ? 'mt-0' : 'mt-5'">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                @switch (view.site.profile.heading.position) {
                @case (1) {
                <app-heading_section-type01
                    [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                @case (2) {
                <app-heading_section-type01
                    [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'assets/xltravel/swoosh-01.svg', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                @case (4) {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
                @case ('4') {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
                }
                } @else {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
            </div>
        </div>
    </div>
    <div class="w-[100%] m-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
            (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)">
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'mat_outline:airplanemode_active'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Air travel reservations
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Domestic and International
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'mat_outline:car_rental'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Car rental reservations
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Domestic and International
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Hotel reservations
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Domestic and International - Including family deals, early booking discounts, and
                            self-catering.
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'feather:compass'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Travel packages
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Domestic and International - Including family deals, early booking discounts, and
                            self-catering.
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Transfer & chauffeur reservations
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Parking, lounge, rail, ferry, cruises, tours, events, group travel.
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'mat_solid:attach_money'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Forex, insurance, passport help
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Assistance with currency exchange, travel insurance, and passport services.
                        </p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                        <mat-icon
                            class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                            [svgIcon]="'heroicons_outline:identification'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <span class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">
                            Visa applications and health advice
                        </span>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">
                            Guidance on visa processes and travel health recommendations.
                        </p>
                    </div>
                </div>
            </fuse-card>
        </ngx-slick-carousel>
    </div>
</section>
} @else {
<section class="w-full bg-white bg-cover bg-no-repeat bg-center dark:bg-slate-800 pt-8 md:pt-10 pb-15 px-6 md:px-15">
    <div class="flex flex-col items-center justify-center mb-8 md:mt-5 lg:mt-10">
        <div class="w-full flex justify-center items-center">
            <div class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center text">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                @switch (view.site.profile.heading.position) {
                @case (1) {
                <app-heading_section-type01
                    [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                @case (2) {
                <app-heading_section-type01
                    [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'assets/xltravel/swoosh-01.svg', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                @case (4) {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
                @case ('4') {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
                }
                } @else {
                <app-heading_section-type01
                    [options]="{ heading:'Services',title:'Top-Quality Solutions',image:'', description:'' }"></app-heading_section-type01>
                }
            </div>
        </div>
    </div>
    <div class="w-[100%] m-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
            (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)">
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_solid:airplanemode_active'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Domestic and international flight bookings</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">We book flights to any destination—local or global—at the best available rates.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Accommodation</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Find the perfect place to stay with options that suit your style and budget.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_outline:car_rental'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Car rental and transfers</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Reliable car hire and seamless transfers to keep your travels stress-free.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_outline:sticky_note_2'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Travel insurance</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Comprehensive coverage for peace of mind on every trip.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'heroicons_outline:document-check'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Visa assistance</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">We guide you through the visa process, making travel paperwork simple.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_outline:beach_access'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Tailor-made holiday packages</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Custom-designed getaways created just for you, from start to finish.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_outline:card_travel'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Corporate and business travel management</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Professional travel solutions to meet your business needs efficiently.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_solid:groups'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Group travel arrangements</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Coordinated travel planning for groups, events, and special occasions.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'mat_outline:directions_boat_filled'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Cruise bookings</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Set sail on world-class cruises with the best itineraries and rates.</p>
                    </div>
                </div>
            </fuse-card>
            <fuse-card ngxSlickItem class="relative my-2 mx-3 isolate flex flex-col px-4 pb-4 pt-4">
                <div class="flex flex-col justify-start items-center p-6 dark:bg-gray-600 group h-[196px] md:h-[210px] lg:h-[224px]">
                    <div
                        class="flex items-center justify-center w-16 h-16 mb-4 md:mb-5 lg:mb-6 group-hover:bg-accent-500 transition ease-out duration-500 rounded-lg border-none md:w-18 md:h-18 lg:h-20 lg:w-20">
                    <mat-icon
                        class="icon-size-10 text-primary-500 group-hover:text-white transition ease-out duration-500"
                        [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
                    </div>
                    <div class="flex flex-col justify-start items-center flex-1">
                        <h3 class="mb-3 text-center text-sm md:text-base lg:text-lg xl:text-xl font-bold tracking-wider">Travel consultation and advice</h3>
                        <p class="text-xs md:text-sm lg:text-base text-center text-gray-600 dark:text-white leading-relaxed">Get expert travel tips and personalized advice every step of the way.</p>
                    </div>
                </div>
            </fuse-card>
        </ngx-slick-carousel>
    </div>
</section>
}
